import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2fb2887a")

_pushScopeId("data-v-2fb2887a")
const _hoisted_1 = { class: "ctrl-buttons" }
const _hoisted_2 = { class: "center title-1" }
const _hoisted_3 = { class: "buttons-container" }
const _hoisted_4 = { class: "buttons-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_simulation_display = _resolveComponent("simulation-display")
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, { class: "main-card" }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("dig-ui-add-button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
          $setup.goTo(
            `/new-simulation/${
              $setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATION].id
            }`,
          )
        )),
          title: $setup.t('Tooltips.duplicateSimulation'),
          class: "icon-button"
        }, null, 8, ["title"]),
        _createVNode("dig-ui-delete-button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (
          $setup.deleteSimulation(
            $setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATION].id,
          )
        )),
          title: $setup.t('Tooltips.deleteSimulation'),
          class: "icon-button"
        }, null, 8, ["title"])
      ]),
      _createVNode("dig-ui-title", _hoisted_2, _toDisplayString($setup.t('mySimulation')), 1),
      _createVNode(_component_simulation_display, {
        simulation: $setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATION]
      }, null, 8, ["simulation"]),
      _createVNode("dig-input-checkbox", {
        id: "emailUser",
        checked: 
        $setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATION].emailUser
      ,
        onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.update({ name: 'emailUser', value: $event.detail })))
      }, _toDisplayString($setup.t('Simulation.emailUser')), 41, ["checked"]),
      _createVNode("dig-input-checkbox", {
        id: "emailContact",
        checked: 
        $setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATION].emailContact
      ,
        onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.update({ name: 'emailContact', value: $event.detail })))
      }, _toDisplayString($setup.t('Simulation.emailContact')), 41, ["checked"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("dig-ui-standard-button", {
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.download())),
          disabled: $setup.loading
        }, _toDisplayString($setup.t('download')), 9, ["disabled"]),
        _createVNode("dig-ui-standard-button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.regenerate())),
          disabled: $setup.loading
        }, _toDisplayString($setup.t('regeneratePDF')), 9, ["disabled"]),
        _createVNode("dig-ui-standard-button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.sendToEmail())),
          disabled: $setup.loading
        }, _toDisplayString($setup.t('sendToEmail')), 9, ["disabled"])
      ]),
      _createVNode("div", null, [
        ($setup.storeSimulation.getters[$setup.StoreGettersSimulation.REPORT])
          ? (_openBlock(), _createBlock("object", {
              key: 0,
              class: "pdf-viewer",
              data: $setup.storeSimulation.getters[$setup.StoreGettersSimulation.REPORT],
              type: "application/pdf"
            }, null, 8, ["data"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("dig-ui-standard-button", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.download())),
          disabled: $setup.loading
        }, _toDisplayString($setup.t('download')), 9, ["disabled"]),
        _createVNode("dig-ui-standard-button", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.regenerate())),
          disabled: $setup.loading
        }, _toDisplayString($setup.t('regeneratePDF')), 9, ["disabled"]),
        _createVNode("dig-ui-standard-button", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.sendToEmail())),
          disabled: $setup.loading
        }, _toDisplayString($setup.t('sendToEmail')), 9, ["disabled"])
      ])
    ]),
    _: 1
  }))
})